// src/components/ui/dialog/dialog.jsx
import * as React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";

const Dialog = DialogPrimitive.Root;

Dialog.displayName = DialogPrimitive.Root.displayName;

export { Dialog };
